<template>
  <div class="form">
    <slide-up-down :active="isFormVisible">
      <form
        class="form-sweepstakes"
        name="sweepstakes"
        method="POST"
        @submit.prevent
      >
        <RowInputText v-bind="initRowWithValidator('fullname')"></RowInputText>
        <RowInputText
          v-bind="initRowWithValidator('policynumber')"
        ></RowInputText>
        <!-- <RowInputText
          v-bind="initRowWithValidator('contractdate')"
        ></RowInputText> -->
        <RowInputText v-bind="initRowWithValidator('phone')"></RowInputText>
        <RowInputText v-bind="initRowWithValidator('email')"></RowInputText>
        <RowInputCheckbox v-bind="initRow('legal')"></RowInputCheckbox>
        <slide-up-down :active="isValidForm" :duration="500">
          <RowSubmit v-bind="initRow('send')"></RowSubmit>
        </slide-up-down>
      </form>
    </slide-up-down>
    <slide-up-down :active="isInProgress">
      <div class="send-status">
        Egy kis türelmet kérünk. Az adatok küldése folyamatban...
      </div>
    </slide-up-down>
    <slide-up-down :active="isSucceded">
      <div class="send-status">
        Jelentkezésed sikeresen rögzítettük. Köszönjük, hogy részt veszel a
        játékunkban. További akcióinkat megtalálod
        <a href="https://union.hu" target="UNION">weboldalunkon</a>!
      </div>
    </slide-up-down>
    <slide-up-down :active="isFailed">
      <div class="send-status">
        Sajnos hiba történt és nem sikerült az adatok küldése. Kérünk,
        próbálkozz újra.
      </div>
    </slide-up-down>
  </div>
</template>

<script>
//import Config from "@/config.js";
import { EventBus } from "@/main.js";

export default {
  name: "FormSweepstakes",
  props: {},
  created: function() {
    var self = this;
    this.$log.debug(this);
    //this.$log.debug(this.$log)
    //this.$log.debug(this.$parent.$parent);

    //handling event notification about updated value
    EventBus.$on("update:value", function(data) {
      //self.$log.debug("event update:value detected", data);
      self.updateValue(data);
    });

    //handling event requesting form submitting
    EventBus.$on("form:requestsubmit", function() {
      self.$log.debug("event form:requestsubmit detected");
      if (self.isValidForm) {
        self.sendForm();
      }
    });

    //self.sendForm();
  },

  //data model
  data: function() {
    return {
      formfields: {
        fullname: { value: "", check: false },
        policynumber: { value: "", check: false },
        // contractdate: { value: "", check: false },
        phone: { value: "", check: false },
        email: { value: "", check: false },
        legal: { value: "", check: false }
      },
      send: {
        succeded: false,
        inprogress: false,
        failed: false
      }
    };
  },

  //computed data
  computed: {
    isFormVisible: function() {
      return !this.send.inprogress && !this.send.succeded;
    },
    isInProgress: function() {
      return this.send.inprogress;
    },
    isSucceded: function() {
      return this.send.succeded && !this.send.inprogress && !this.send.failed;
    },
    isFailed: function() {
      return !this.send.succeeded && !this.send.inprogress && this.send.failed;
    },

    //returns true if every field is chacked, otherwise returns false
    isValidForm: function() {
      for (var key in this.formfields) {
        if (
          Object.prototype.hasOwnProperty.call(this.formfields, key) === true &&
          this.formfields[key].check === false
        ) {
          return false;
        }
      }
      return true;
    }
  },

  //watching variables
  watch: {},

  //component methods
  methods: {
    //returns a validator function based on text inputfield row id
    getValidator: function(id) {
      var fnNames = {
        fullname: "validateFullname",
        policynumber: "validatePolicytravel",
        // contractdate: "validateContractDate",
        phone: "validateMobileHu",
        email: "validateEmail"
      };
      return Object.prototype.hasOwnProperty.call(fnNames, id) === true
        ? this.$kRevoValidator()[fnNames[id]]
        : this.$kRevoValidator().validate;
    },

    //returns an object containing props needed for text input rows
    initRowWithValidator: function(id) {
      var result = this.initRow(id);
      result.validate = this.getValidator(id);
      return result;
    },

    //returns an object containing props needed for text input rows
    initRow: function(id) {
      return {
        id: id
      };
    },

    //updates values with valued recieved from text input rows
    updateValue: function(data) {
      //this.$log.debug("updateValue called", data);
      this.$data.formfields[data.id].value = data.value;
      this.$data.formfields[data.id].check = data.check;
    },

    //returns the candidate data string for submitting
    getCandidatedata() {
      return (
        this.formfields.fullname.value +
        "; ; " +
        this.formfields.email.value +
        "; " +
        this.$kRevoValidator().filterphoneHu(this.formfields.phone.value) +
        "; ; ; ;"
      );
    },

    //returns a FormData obvject suitable for sending with Axios POST
    //Using form data is extremely important for populating $_POST in PHP
    getFormData() {
      var params = new FormData();
      params.append("sweepstakes", this.$kRevoUrl().getSweepstake().title);
      params.append("candidatedata", this.getCandidatedata());
      // params.append(
      //   "candidateinfo",
      //   "Kötvényszám: " + this.formfields.policynumber.value
      // );
      params.append("candidateinfo", this.formfields.policynumber.value);
      return params;
    },

    //returns the URL wehere the data will be posted
    getFormUrl() {
      return process.env.VUE_APP_POST_URL;
    },

    //returns the URL wehere the data will be posted
    getFormOptions() {
      return {
        headers: {
          "content-type": "text/plain;charset=utf-8;"
        }
      };

      //self.axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
      /*var config = {
        headers{
          "content-type": "multipart/form-data; charset=utf-8;"
          "content-type": "text/plain;charset=utf-8"
          "content-type": "application/x-www-form-urlencoded;"
          "content-type": "multipart/form-data;"
          "content-type": "application/json;"
        }
      };*/
    },

    //updates values with value recieved from text input rows
    sendForm: function() {
      var self = this;
      this.$log.debug("form is valid and should be sent");
      EventBus.$emit("loader:show", "sendFormData");
      self.send.succeded = false;
      self.send.failed = false;
      self.send.inprogress = true;
      self.axios
        .post(this.getFormUrl(), this.getFormData(), this.getFormOptions())
        .then(function(response) {
          self.$log.debug("data sent", response);
          EventBus.$emit("loader:hide", "sendFormData");
          self.send.succeded = true;
          self.send.failed = false;
          self.send.inprogress = false;
        })
        .catch(function(error) {
          self.$log.debug("data sent error", error);
          self.send.succeded = false;
          self.send.failed = true;
          self.send.inprogress = false;
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.form-sweepstakes {
  position: relative;
  display: block;
  box-sizing: border-box;
  margin: 0px;
  padding: 0px;
  font-size: 1em;
}

.send-status {
  position: relative;
  display: block;
  box-sizing: border-box;
  font-size: 1em;
  margin: 0px;
  padding: 0.5em 2.5em 0px 0px;
  color: $colorGrayDark;
  font-family: $font-family-normal;

  a {
    text-decoration: underline;
    color: $colorGrayDark;
  }
}
</style>
